import React from 'react';
import { motion } from 'framer-motion';
import { Filter, Map, Waves, Moon } from 'lucide-react';
export function SolutionSection() {
  const steps = [{
    number: '1',
    title: 'Filtrar estímulos',
    desc: 'bajar luz/ruido/actividad',
    icon: Filter
  }, {
    number: '2',
    title: 'Fijar señales',
    desc: 'leer 3 pistas rápidas y elegir ruta',
    icon: Map
  }, {
    number: '3',
    title: 'Fluir con el cuerpo',
    desc: 'movimiento/contención según ruta',
    icon: Waves
  }, {
    number: '4',
    title: 'Finalizar con cierre',
    desc: 'rutina PM mínima para «apagar» el día',
    icon: Moon
  }];
  return <section className="py-12 px-4 md:px-6 bg-white" data-id="element-156">
      <div className="max-w-5xl mx-auto" data-id="element-157">
        <div className="text-center mb-10 max-w-3xl mx-auto" data-id="element-158">
          <h2 className="font-serif text-2xl md:text-4xl text-[#1a2e4a] font-bold mb-3" data-id="element-159">
            La solución: Protocolo 4F (20 min) + Mapa de decisiones
          </h2>
          <p className="text-lg text-[#5a5a5a]" data-id="element-160">
            Este sistema está hecho para que puedas aplicarlo aunque estés sin
            dormir.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-10" data-id="element-161">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#faf6f0] p-4 md:p-5 rounded-2xl border border-[#d4a0a0]/20 relative overflow-hidden group hover:shadow-lg transition-shadow duration-300" data-id="element-162">
              <div className="absolute -right-4 -top-4 w-16 h-16 bg-[#c4956a]/10 rounded-full group-hover:bg-[#c4956a]/20 transition-colors" data-id="element-163"></div>

              <div className="w-10 h-10 bg-[#1a2e4a] text-[#c4956a] rounded-full flex items-center justify-center mb-3 relative z-10" data-id="element-164">
                <step.icon size={20} data-id="element-165" />
              </div>

              <div className="text-3xl font-serif font-bold text-[#c4956a]/20 absolute top-3 right-3" data-id="element-166">
                {step.number}
              </div>

              <h3 className="font-serif text-base md:text-lg font-bold text-[#1a2e4a] mb-1 relative z-10" data-id="element-167">
                {step.title}
              </h3>
              <p className="text-[#5a5a5a] text-xs md:text-sm leading-relaxed relative z-10" data-id="element-168">
                {step.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#1a2e4a] p-5 md:p-8 rounded-3xl text-center text-[#faf6f0] max-w-3xl mx-auto shadow-xl" data-id="element-169">
          <p className="text-lg md:text-xl font-serif leading-relaxed" data-id="element-170">
            Y cuando te ataque la duda («¿hambre o cansancio o gases?»), no te
            quedas pensando: abres el{' '}
            <span className="text-[#c4956a] font-bold" data-id="element-171">
              Mapa «si pasa X → haz Y»
            </span>{' '}
            y ejecutas.
          </p>
        </motion.div>
      </div>
    </section>;
}